import { Table, Thead, Tbody, Tr, Th, Td, Box, Text } from '@chakra-ui/react';

export const OptionsTable = () => {
	return (
		<Box my="20px">
			<Text fontSize="2xl" my="20px">
				Options
			</Text>
			<Table size="md" border="1px" borderColor="gray">
				<Thead>
					<Tr>
						<Th>Option</Th>
						<Th>Description</Th>
						<Th>Default</Th>
					</Tr>
				</Thead>
				<Tbody>
					<Tr>
						<Td>type</Td>
						<Td>Specify the type of progress bar. you can choose between | regular | striped</Td>
						<Td>regular</Td>
					</Tr>
					<Tr>
						<Td>maxValue</Td>
						<Td>Maximum value in percentage showing end of progress. (number)</Td>
						<Td>100</Td>
					</Tr>
					<Tr>
						<Td>height</Td>
						<Td>Height of Progress Bar in px </Td>
						<Td>15px</Td>
					</Tr>
					<Tr>
						<Td>borderRadius</Td>
						<Td>The border radius of progress Bar in px</Td>
						<Td>10px</Td>
					</Tr>
					<Tr>
						<Td>barColor</Td>
						<Td>The hex color of the inner bar which show the current progress</Td>
						<Td>#2c43ac</Td>
					</Tr>
					<Tr>
						<Td>stripeAnimation</Td>
						<Td>Toggle striped animation on and off. should set type as "striped" </Td>
						<Td>false</Td>
					</Tr>
					<Tr>
						<Td>stripeAnimationDuration</Td>
						<Td>Duration of stripe animation in seconds</Td>
						<Td>10s</Td>
					</Tr>
					<Tr>
						<Td>containerStyle</Td>
						<Td>Style of the outer container you can choose between | bg | border | none </Td>
						<Td>bg</Td>
					</Tr>
					<Tr>
						<Td>containerColor</Td>
						<Td>color of the outer container </Td>
						<Td>#dddddd</Td>
					</Tr>
					<Tr>
						<Td>labelAlignment</Td>
						<Td>The alignment of the label choose between | left | center | right </Td>
						<Td>left</Td>
					</Tr>
					<Tr>
						<Td>labelSize</Td>
						<Td>Font size of label</Td>
						<Td>12px</Td>
					</Tr>
					<Tr>
						<Td>labelVisibility</Td>
						<Td>Toggle label on or off</Td>
						<Td>true</Td>
					</Tr>
					<Tr>
						<Td>labelColor</Td>
						<Td>Color of label</Td>
						<Td>white</Td>
					</Tr>
					<Tr>
						<Td>customLabel</Td>
						<Td>Add your own custom label</Td>
						<Td />
					</Tr>
				</Tbody>
			</Table>
		</Box>
	);
};
